import config from '@/modules/config/functions/config';
import customFormatters from '@/modules/i18n/constants/customFormatters';
import initOptions from '@/modules/i18n/constants/init-options';
import i18n from 'i18next';
import browserLanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

/**
 * Load translation files
 * @param language - The language to load
 * @param namespace - The namespace to load
 * @returns The translation files
 */
async function loadTranslation(language: string, namespace: string) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return import(
    `../assets/locales/${language}/${namespace}.ts`
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  ).then((d) => d);
}

/**
 * Initialize i18n
 * @returns The i18n t function
 */
export default async function setupI18n() {
  const languages = config('i18n.languages', {});

  return i18n
    .use(initReactI18next)
    .use(browserLanguageDetector)
    .use(resourcesToBackend(loadTranslation))
    .init({
      supportedLngs: Object.keys(languages),
      fallbackLng: config('i18n.fallbackLanguage'),
      // lng: config('i18n.defaultLanguage'),
      ...initOptions,
    })
    .then(() => {
      Object.entries(customFormatters).forEach(([key, { type, fn }]) => {
        if (type === 'addCached') {
          i18n.services?.formatter?.addCached(key, fn);
        }
      });
    });
}
